import { render } from "./SensorEventsPage.vue?vue&type=template&id=932dd280&scoped=true"
import script from "./SensorEventsPage.vue?vue&type=script&lang=js"
export * from "./SensorEventsPage.vue?vue&type=script&lang=js"

import "./SensorEventsPage.vue?vue&type=style&index=0&id=932dd280&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-932dd280"]])

export default __exports__